import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Partnerships from './components/Partnerships';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import AdditionalProducts from './components/AdditionalProducts';
import Blog from './components/Blog';
import Footer from './components/Footer';
import CityModal from './components/CityModal';
import VehicleBrandsModal from './components/VehicleBrandsModal';
import './App.css';

// Importar utilitário de teste de imagens (apenas em desenvolvimento)
if (process.env.NODE_ENV === 'development') {
  import('./utils/imageTest');
}

function App() {
  const [showCityModal, setShowCityModal] = useState(false);
  const [showVehicleBrandsModal, setShowVehicleBrandsModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);

  const handleOrderNow = () => {
    setShowCityModal(true);
  };

  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setShowCityModal(false);
    setShowVehicleBrandsModal(true);
  };

  const handleVehicleSelect = (vehicleData) => {
    setShowVehicleBrandsModal(false);
    // Aqui você pode redirecionar para a página de produto
    console.log('Veículo selecionado:', vehicleData);
    // Exemplo: { brand: {...}, model: {...}, city: {...} }
  };

  return (
    <div className="App">
      <Header onOrderNow={handleOrderNow} />
      <Hero onOrderNow={handleOrderNow} />
      <HowItWorks onOrderNow={handleOrderNow} />
      <Partnerships />
      <Testimonials />
      <FAQ />
      <AdditionalProducts onOrderNow={handleOrderNow} />
      <Blog />
      <Footer />
      
      {showCityModal && (
        <CityModal 
          onClose={() => setShowCityModal(false)}
          onCitySelect={handleCitySelect}
        />
      )}
      
      {showVehicleBrandsModal && (
        <VehicleBrandsModal 
          onClose={() => setShowVehicleBrandsModal(false)}
          onVehicleSelect={handleVehicleSelect}
          selectedCity={selectedCity}
        />
      )}
      
      {/* WhatsApp Floating Button */}
      <a 
        href="https://wa.me/5540205278?text=Olá! Gostaria de saber mais sobre as baterias automotivas."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

export default App;
